import { MapCamera, projectMapX } from './mapDesign';

// Authored GameZone positions and uphill endpoints from this atlas's navmesh.
export const ATLAS_GAMES = [
  { label: 'Tic-tac-toe', icon: '×○', x: 12.95, z: -24.94 },
  { label: 'Chess', icon: '♟', x: -11.74, z: -24.8 },
];
export const ATLAS_RAMPS = [
  { from: { x: 12, z: -32 }, to: { x: 22.4, z: -32 } },
  { from: { x: -12, z: -32 }, to: { x: -23, z: -32 } },
  { from: { x: 7, z: -44 }, to: { x: 10.4, z: -50 } },
  { from: { x: -7, z: -44 }, to: { x: -11.4, z: -50 } },
];

/** Lightweight, world-anchored signs shared by the preview and live atlas. */
export function drawAtlasWayfinding(ctx: CanvasRenderingContext2D, camera: MapCamera) {
  if (camera.y > 4) return;
  const compact = camera.scale < 8;
  const sx = (x: number) => projectMapX(x, camera);
  const sy = (z: number) => camera.height / 2 + (z - camera.z) * camera.scale;
  const label = (text: string, x: number, y: number, color: string) => {
    ctx.font = `700 ${compact ? 10 : 12}px system-ui`;
    const width = ctx.measureText(text).width + 16;
    ctx.fillStyle = '#102735';
    ctx.fillRect(x - width / 2, y - 10, width, 22);
    ctx.strokeStyle = color; ctx.lineWidth = 1;
    ctx.strokeRect(x - width / 2, y - 10, width, 22);
    ctx.fillStyle = color; ctx.fillText(text, x, y + 4);
  };
  ctx.save(); ctx.textAlign = 'center'; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  ATLAS_RAMPS.forEach(({ from, to }, index) => {
    const x = sx(from.x), y = sy(from.z), tx = sx(to.x), ty = sy(to.z);
    const angle = Math.atan2(ty - y, tx - x);
    // Dark casing keeps the gold uphill arrow visible on pale walkways.
    [8, 4].forEach((width, pass) => {
      ctx.strokeStyle = pass ? '#ffdb70' : '#102735'; ctx.lineWidth = width;
      ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(tx, ty);
      ctx.moveTo(tx - 8 * Math.cos(angle - .6), ty - 8 * Math.sin(angle - .6));
      ctx.lineTo(tx, ty);
      ctx.lineTo(tx - 8 * Math.cos(angle + .6), ty - 8 * Math.sin(angle + .6)); ctx.stroke();
    });
    // At overview scale the two rear ramps share a label to avoid collisions.
    if (index < 2 || !compact) label(compact ? '↑ UPSTAIRS' : 'RAMP · UPSTAIRS', (x + tx) / 2, Math.min(y, ty) - 16, '#ffdb70');
  });
  if (compact) label('RAMPS · UPPER FLOOR', sx(0), sy(-55), '#ffdb70');
  label('GAMES', sx(0), sy(-13), '#a5f1dd');
  ATLAS_GAMES.forEach(game => {
    const x = sx(game.x), y = sy(game.z);
    ctx.fillStyle = '#a5f1dd'; ctx.strokeStyle = '#102735'; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.arc(x, y, compact ? 11 : 15, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
    ctx.fillStyle = '#102735'; ctx.font = `700 ${compact ? 14 : 19}px system-ui`;
    ctx.fillText(game.icon, x, y + (compact ? 5 : 6));
    label(game.label, x, y + (compact ? 25 : 31), '#a5f1dd');
  });
  ctx.restore();
}
